import {Routes,RouterModule} from '@angular/router'; 
import { NgModule } from '@angular/core';
import { ManualAccessComponent } from './manual-access.component';



const routes : Routes = [
    {
    path:'',
    component:ManualAccessComponent
    }
];

@NgModule({
imports: [RouterModule.forChild(routes)],
exports: [RouterModule]
})

export class manualdataaccessRoutingModule {}